import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }
}

// api
export const reuseableListingApi = async ({ payload }) => {
    let request = {}

    if (payload?.value) {
        request = requestAuthOption("GET", payload?.value)
    } else {
        request = requestAuthOption("GET")

    }
    try {
        const response = await fetch(`${server}${payload?.api || ""}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve({ data: data, api: payload?.api });
                    } else {
                        reject(["No data"]);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
        // if (response.ok) {
        //     const data = await response.json(); // Parse JSON data
        //     if (data.code === "success") {
        //         return data; // Return the data
        //     } else {
        //         apiError("ReuseableSettingname and password are invalid. Please enter correct username and password");
        //         return false; // Custom error message
        //     }
        // } else {
        //     throw new Error('Network response was not ok');
        // }
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const reuseableDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}${payload?.api || ""}/${payload?.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid field") {
                        reject(["No data"]);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const reuseableAddApi = async (payload) => {
    const request = requestAuthOption("POST", payload?.reuseable)
    try {
        const response = await fetch(`${server}${payload?.api || ""}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data.errors);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const reuseableDeleteApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(`${server}${payload?.api}/${payload?.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};
export const reuseableUpdateApi = async (payload) => {
    const request = requestAuthOption("PUT", payload?.reuseable)
    try {
        const response = await fetch(`${server}${payload?.api}/${payload?.id || ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data.errors);

                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};
export const reuseableExportApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(`${server}${payload?.api || ""}/export`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {

        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

